// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_flexi_pin_hinge/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_flexi_pin_hinge: ModuleSchema = {
  "id": "core_flexi_pin_hinge",
  "uniqueId": "B3D_7K9PH",
  "createdAt": "2026-10-16T00:00:00Z",
  "updatedAt": "2026-10-16T14:14:28.699Z",
  "label": "Flexi Pin Hinge",
  "description": "Two clicker links joined print-in-place by a horizontal chamfered eyelet loop capturing a vertical pivot pin in a flared receiver pocket (CG_FPH01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_FPH01",
    "flexi-link",
    "print-in-place-joint",
    "pivot-pin"
  ],
  "sliders": [
    {
      "key": "pinWidth",
      "label": "Pivot Pin Width",
      "min": 1.8,
      "max": 5,
      "default": 3.4,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "pinDepth",
      "label": "Pivot Pin Depth",
      "min": 1.4,
      "max": 4,
      "default": 2.1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "clearance",
      "label": "Joint Running Clearance",
      "min": 0.25,
      "max": 1,
      "default": 0.6,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopWall",
      "label": "Eyelet Wall Thickness",
      "min": 1,
      "max": 3,
      "default": 1.8,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopThickness",
      "label": "Eyelet Loop Thickness",
      "min": 3.5,
      "max": 9,
      "default": 5.85,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "chamferHeight",
      "label": "45° Chamfer Height",
      "min": 0.5,
      "max": 2.5,
      "default": 1.35,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "pocketWidth",
      "label": "Pocket Mouth Width",
      "min": 8,
      "max": 16,
      "default": 11,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "swingAngle",
      "label": "Pocket Swing Flare Angle",
      "min": 40,
      "max": 90,
      "default": 70,
      "step": 1,
      "unit": "deg",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "clicker_bodies",
      "label": "Links, Pocket, Pin and Eyelet",
      "default": "#F59E0B",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "mx_switch_sim",
      "label": "MX Switch Simulations",
      "default": "#6CC7C3",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keycaps",
      "label": "Keycaps",
      "default": "#F4F1E8",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "clicker_pair",
      "label": "Two Flexi-Linked Clickers",
      "name": "Two Flexi-Linked Clickers",
      "color": "#F59E0B",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "clicker_bodies",
          "label": "Links, Pocket, Pin and Eyelet",
          "name": "Links, Pocket, Pin and Eyelet",
          "groupId": 0,
          "colorKey": "clicker_bodies",
          "defaultColor": "#F59E0B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "mx_switch_sim",
          "label": "MX Switch Simulations",
          "name": "MX Switch Simulations",
          "groupId": 1,
          "colorKey": "mx_switch_sim",
          "defaultColor": "#6CC7C3",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "keycaps",
          "label": "Keycaps",
          "name": "Keycaps",
          "groupId": 2,
          "colorKey": "keycaps",
          "defaultColor": "#F4F1E8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Two Linked Clickers"
    },
    {
      "id": "0",
      "label": "Download STL - Links and Print-in-Place Joint"
    },
    {
      "id": "1",
      "label": "Download STL - Switch Simulations"
    },
    {
      "id": "2",
      "label": "Download STL - Keycaps"
    }
  ]
};
